import { RunContextApp } from 'framework/RCApp';
import { createAuditApiClient as createReal } from '../../apis/auditAPI';

export function createAuditApiClient(rc: RunContextApp, baseUrl: string) {
  const realClient = createReal(rc, baseUrl);
  return {
    getProjectAuditEvents: realClient.getProjectAuditEvents.bind(realClient),
    getUserAuditEvents: realClient.getUserAuditEvents.bind(realClient),
    getAuditEventTypes: realClient.getAuditEventTypes.bind(realClient),
    getAuditSources: realClient.getAuditSources.bind(realClient),
  };
}
